// extracted by mini-css-extract-plugin
export default {"root":"syyl_","title":"_3cf04"};